import { VariantProps } from "class-variance-authority";
import { Captions, CaptionsOff } from "lucide-react";
import { forwardRef } from "react";

import { useVidyoStore } from "@/features/vidyo-call/utils/vidyo-store";

import { ActionButton, ActionButtonProps } from "../action-button";

type ToggleCaptionProps = Omit<ActionButtonProps, "Icon" | "text"> &
  VariantProps<typeof ActionButton> & {
    variant?: "default" | "ghost" | "destructive";
    size?: "fixed" | "auto";
  };

export const ToggleCaption = forwardRef<HTMLButtonElement, ToggleCaptionProps>(
  ({ variant = "default", size = "fixed", ...props }, ref) => {
    const isCaptionEnabled = useVidyoStore(
      (state) => state.closedCaptioning.enabled,
    );
    const isVidyoConnected = useVidyoStore((state) => state.isVidyoConnected);
    const setCaptionEnabled = useVidyoStore(
      (state) => state.closedCaptioning.setEnabled,
    );
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setCaptionEnabled(!isCaptionEnabled);

      // Call the original onClick handler if it exists,
      // this closes the dropdown menu
      props.onClick?.(event);
    };

    return (
      <ActionButton
        {...props}
        ref={ref}
        variant={variant}
        size={size}
        onClick={handleClick}
        Icon={isCaptionEnabled ? Captions : CaptionsOff}
        text={isCaptionEnabled ? "Disable Caption" : "Enable Caption"}
        key="caption"
        isActive={isCaptionEnabled}
        disabled={!isVidyoConnected}
      />
    );
  },
);

ToggleCaption.displayName = "ToggleCaption";
